import * as React from "react"
import { useGeolocated } from "react-geolocated"
import * as classNames from "./SearchAgencySection.module.scss"
import CtxHeroSection from "../../../common/sections/ctx-hero-section/CtxHeroSection"
import { useEffect, useState } from "react"
import Axios from "axios"

const SearchAgencySection = ({
  image,
  agenciesData,
  regionsDepartementsData,
}) => {
  const { coords, getPosition } =
    useGeolocated({
      suppressLocationOnMount: true,
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 5000,
    })

  const [searchTerm, setSearchTerm] = useState()

  const [suggestions, setSuggestions] = useState()

  const agenciesByDepartements = {}

  for (const agencyData of agenciesData) {
    for (const dep of agencyData.attributes.zoneDepartements.data) {
      agenciesByDepartements[dep.attributes.code] = {
        url: "/" + agencyData.attributes.slug,
      }
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const data = await Axios.get(
        "https://api-adresse.data.gouv.fr/reverse/",
        { params: { lon: coords.longitude, lat: coords.latitude } }
      )
      if (data?.data?.features?.length > 0) {
        setSearchTerm(data.data.features[0].properties.city)
      }
    }
    if (coords) {
      fetchData().catch(console.error)
    }
  }, [coords])

  useEffect(() => {
    console.log("regionsDepartementsData", regionsDepartementsData)

    let regions = []
    if (searchTerm && searchTerm.length > 1) {
      regions = regionsDepartementsData
        .filter((r) => {
          var string_norm = r.attributes.name
            .normalize("NFD")
            .replace(/\p{Diacritic}/gu, "")
            .toLowerCase()
          return string_norm.startsWith(searchTerm.toLowerCase())
        })
        .map((r) => {
          return {
            url: r.attributes.autoRoute,
            label: "Région " + r.attributes.name,
          }
        })
    }

    const departements = []
    if (searchTerm && searchTerm.length > 1) {
      regionsDepartementsData.forEach((re) => {
        re.attributes.departements.data
          .filter((r) => {
            var string_norm = r.attributes.name
              .normalize("NFD")
              .replace(/\p{Diacritic}/gu, "")
              .toLowerCase()
            return string_norm.startsWith(searchTerm.toLowerCase())
          })
          .map((r) => {
            departements.push({
              url: r.attributes.autoRoute,
              label: "Departement " + r.attributes.name,
            })
          })
      })
    }

    const fetchData = async () => {
      const data = await Axios.get("https://api-adresse.data.gouv.fr/search/", {
        params: { q: searchTerm, limit: 20 },
      })
      if (data?.data?.features?.length > 0) {
        const municipality = data.data.features
          .filter((f) => f.properties.type === "municipality")
          .map((s) => {
            return {
              url:
                agenciesByDepartements[s.properties.citycode.slice(0, 2)]
                  ?.url || "/",
              label: `${s.properties.label} - ${s.properties.context}`,
            }
          })

        setSuggestions([...regions, ...departements, ...municipality])
      } else {
        setSuggestions([...regions, ...departements])
      }
    }
    if (searchTerm?.length > 2) {
      fetchData().catch(console.error)
    } else {
      setSuggestions([...regions, ...departements])
    }
  }, [searchTerm])

  return (
    <CtxHeroSection
      image={image}
      imgSrc={image.url}
      imgAlt={image.alt}
      classes="mb-5"
    >
      <div className={`${classNames.article_header} fade-in-bottom`}>
        <div className="row clearfix hero_small_agence container flex items-center relative">
          <div className="column full flex flex-col justify-center items-start fade-in-bottom">
            <div
              className={`${classNames.header_card} card container card_bottom flex flex-direction-column justify-content-end align-items-center text-center pbl-6 fade-in-bottom gap-4`}
            >
              <h1>Trouvez votre agence Paritel la plus proche</h1>
              <div className="flex align-items-center w-100">
                <form
                  className="searchForm flex gap-3 w-100"
                  method="GET"
                  action="/?search"
                >
                  
                  <div className="form-control mb-0 w-100 relative">
                    <input
                      type="search"
                      name="q"
                      placeholder="Paris, Bordeaux..."
                      autocomplete="off"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value)
                      }}
                      required="true"
                    />
                    {suggestions && suggestions.length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          backgroundColor: "white",
                          top: "60px",
                          padding: "20px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "24px",
                        }}
                        className={classNames.suggestions_panel + " card"}
                      >
                        {suggestions?.map((s) => {
                          return (
                            <div>
                              <a
                                href={s.url}
                                key={s.label}
                                style={{
                                  color: "black",
                                  textDecoration: "none",
                                }}
                              >
                                {s.label}
                              </a>
                            </div>
                          )
                        })}
                      </div>
                    )}
                    <button
                      className="unstyled"
                      onClick={(e) => {
                        e.preventDefault()
                        getPosition()
                      }}
                      style={{
                        position: "absolute",
                        top: "16px",
                        right: "24px",
                      }}
                    >
                      <svg
                        className="icon"
                        width="22"
                        height="22"
                        viewBox="0 0 17 23"
                        fill="none"
                      >
                        <path
                          d="M8.50017 5.15197H8.5C7.76731 5.15197 7.05152 5.38673 6.44316 5.8259C5.83488 6.26503 5.36147 6.88864 5.08208 7.61736C4.8027 8.34606 4.72967 9.14766 4.87204 9.92097C5.01442 10.6943 5.36594 11.4052 5.88283 11.9637C6.39977 12.5222 7.059 12.9031 7.77745 13.0575C8.49595 13.2119 9.24064 13.1326 9.91711 12.8299C10.5935 12.5272 11.1708 12.015 11.5767 11.3587C11.9825 10.7026 12.1989 9.93155 12.1989 9.14319V9.14305C12.1964 8.08685 11.807 7.07378 11.1145 6.32558C10.4218 5.57721 9.482 5.15461 8.50017 5.15197ZM8.50008 0.4375L8.49992 0.4375C6.36075 0.440122 4.31097 1.35943 2.79994 2.99195C1.28905 4.62431 0.439922 6.83655 0.4375 9.14313V9.14319C0.4375 12.2452 1.76318 15.5293 4.26957 18.6311C5.39612 20.0359 6.66131 21.3038 8.04271 22.4121L8.04265 22.4122L8.04532 22.4141C8.17954 22.5106 8.33774 22.5625 8.5 22.5625C8.66227 22.5625 8.82047 22.5106 8.95468 22.4141L8.95473 22.4142L8.95719 22.4122C10.3427 21.3054 11.6112 20.0374 12.7397 18.6309C15.2369 15.5292 16.5625 12.2451 16.5625 9.14319V9.14313C16.5601 6.83655 15.711 4.62431 14.2001 2.99195C12.689 1.35943 10.6392 0.440122 8.50008 0.4375ZM8.49994 11.4379C8.08192 11.4379 7.67285 11.304 7.32443 11.0525C6.97592 10.8009 6.7036 10.4428 6.54262 10.0229C6.38163 9.60299 6.33945 9.14069 6.42157 8.69464C6.50369 8.2486 6.70629 7.83949 7.00309 7.51883C7.29984 7.19822 7.67731 6.9805 8.08748 6.89236C8.4976 6.80422 8.92275 6.8494 9.30942 7.02244C9.69616 7.19551 10.0275 7.48896 10.261 7.86646C10.4944 8.24393 10.6193 8.68815 10.6193 9.14295C10.617 9.75233 10.3918 10.3352 9.99427 10.7647C9.59688 11.194 9.05967 11.4354 8.49994 11.4379ZM8.5 20.6508C7.73489 19.9958 6.13486 18.5236 4.71569 16.5298C3.2705 14.4994 2.01705 11.9339 2.01705 9.14319C2.01705 7.28274 2.70115 5.49937 3.91753 4.1852C5.13376 2.87119 6.78224 2.13399 8.5 2.13399C10.2178 2.13399 11.8662 2.87119 13.0825 4.1852C14.2988 5.49937 14.983 7.28274 14.983 9.14319C14.983 11.9339 13.7295 14.4994 12.2843 16.5298C10.8651 18.5236 9.26511 19.9958 8.5 20.6508Z"
                          fill="var(--gris)"
                          stroke="white"
                          stroke-width="0.125"
                        ></path>
                      </svg>
                    </button>
                  </div>
                  {/* <div className="form-control mb-0">
                    <button
                      className="contrastant primary large"
                      type="submit"
                    >
                      Rechercher
                    </button>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <Card className="container card_bottom flex flex-direction-column justify-content-end align-items-center text-center pbl-6 pin-3">
          <h1>{title}</h1>
          <div
            className={`flex flex-direction-row align-items-center ${classNames.article_metas}`}
          >
            <input
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value)
              }}
            ></input>
          </div>
          <div>
            {suggestions?.map((s) => {
              const dep = s.properties.citycode.slice(0, 2)
              return (
                <div>
                  <a
                    href={agenciesByDepartements[dep]?.url || "/"}
                    key={s.properties.label}
                  >
                    {s.properties.label} - {s.properties.context}
                  </a>
                </div>
              )
            })}
          </div>
        </Card> */}
      </div>
    </CtxHeroSection>
  )
}

export const name = "SearchAgencySection"

export const init = (componentData, pageContext) => {
  return (
    <SearchAgencySection
      key={componentData.id}
      title={componentData.label}
      image={componentData.backgroundImage.data?.attributes}
      agenciesData={pageContext.slAgenciesData}
      regionsDepartementsData={pageContext.regionsDepartementsData}
    />
  )
}

export default SearchAgencySection
